import React, { useState, useEffect } from 'react';

const ProgressiveComponentLoader = ({ 
    data, 
    component: Component, 
    chunkSize = 50,
    loadingComponent: LoadingComponent,
    children, // ✅ AGREGAR CHILDREN
    ...props 
}) => {
    const [visibleData, setVisibleData] = useState([]);
    const [isStreaming, setIsStreaming] = useState(false);
    
    useEffect(() => {
        if (!data || data.length === 0) {
            setVisibleData([]);
            return;
        }
        
        setIsStreaming(true);
        let currentIndex = 0;
        
        const streamInterval = setInterval(() => {
            if (currentIndex >= data.length) {
                clearInterval(streamInterval);
                setIsStreaming(false);
                return;
            }
            
            const nextChunk = data.slice(0, currentIndex + chunkSize);
            setVisibleData(nextChunk);
            currentIndex += chunkSize;
        }, 100);
        
        return () => clearInterval(streamInterval);
    }, [data, chunkSize]);
    
    if (!data || data.length === 0) {
        return LoadingComponent || null;
    }
    
    return (
        <>
            {/* ✅ OPCIÓN 1: Si se pasa Component como prop */}
            {Component && <Component data={visibleData} {...props} />}
            
            {/* ✅ OPCIÓN 2: Si se pasa como children */}
            {!Component && children && React.cloneElement(children, { data: visibleData, ...props })}
            
            {isStreaming && data.length > 50 && (
                <div className="text-center p-2">
                    <small className="text-muted">
                        Cargando... {visibleData.length.toLocaleString()}/{data.length.toLocaleString()}
                    </small>
                </div>
            )}
        </>
    );
};

export default ProgressiveComponentLoader;